const SEARCH_ROUTE_PATTERNS = [
  /^\/$/,
  /^\/panel\/calendar$/,
  /^\/calendar\/\d+/,
  /^\/products\/\d+/,
  /^\/panel\/edit_order\/\d+/,
  /^\/panel\/orders\//,
];

const HIDDEN_CHROME_PATTERNS = [/^\/login$/, /^\/panel\/enable-location$/];

export const shouldHideVisitorChrome = (pathname) =>
  HIDDEN_CHROME_PATTERNS.some((pattern) => pattern.test(pathname));

export const shouldShowDefaultSearch = (pathname) =>
  !SEARCH_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));

export const getMenuActiveFromPath = (pathname) => {
  if (pathname === "/" || /^\/products\/\d+/.test(pathname)) {
    return "shop";
  }
  if (
    pathname === "/panel/calendar" ||
    /^\/calendar\/\d+/.test(pathname)
  ) {
    return "calendar";
  }
  if (pathname === "/panel/map") {
    return "map";
  }
  if (
    pathname === "/panel/cart" ||
    pathname.startsWith("/panel/orders/") ||
    pathname.startsWith("/panel/factor/") ||
    pathname.startsWith("/panel/show_factor/") ||
    pathname.startsWith("/panel/payment/") ||
    pathname.startsWith("/panel/pay/") ||
    pathname.startsWith("/panel/return/") ||
    pathname.startsWith("/panel/comeback/") ||
    pathname.startsWith("/panel/customer-return/")
  ) {
    return "cart";
  }
  if (
    pathname.startsWith("/panel/setting") ||
    pathname.startsWith("/panel/profile") ||
    pathname.startsWith("/panel/reports") ||
    pathname.startsWith("/panel/notifications") ||
    pathname.startsWith("/panel/research") ||
    pathname.startsWith("/panel/add_shop") ||
    pathname.startsWith("/panel/edit/")
  ) {
    return "setting";
  }
  return "";
};
